import { TradingOfferType } from 'types/TradingOffer';

import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';
import TradingOffersList from '../pages/TradingOffersList';

const TradingSellOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList tradingOfferType={TradingOfferType.SELL} />
  </TradingOffersListProvider>
);

export default TradingSellOffersListContainer;
